import { constantRoutes } from "@/router";
import menuRoutes from "@/router/menu";
import userSate from "./user";
const menuMap = {};
const permission = {
  state: {
    routes: [],
    addRoutes: [],
    menus: [],
    annualInfo: {}
  },
  mutations: {
    SET_ROUTES: (state, routes) => {
      state.addRoutes = routes;
      state.routes = constantRoutes.concat(routes);
    },
    SET_ANNUALINFO: (state, data) => {
      state.annualInfo = data;
    }
  },
  actions: {
    GenerateRoutes({ commit, state }, role) {
      return new Promise(resolve => {
        if (role == 1) {
          //auditManager
          filterMenuRoute(menuRoutes, role, false);
          menuRoutes.push({ path: "*", redirect: "/404", hidden: true });
          commit("SET_ROUTES", menuRoutes);
          resolve(menuRoutes);
        } else {
          //producer
          filterMenuRoute(menuRoutes, role, isAnnualNav, userStatus);
          menuRoutes.push({ path: "*", redirect: "/404", hidden: true });
          commit("SET_ROUTES", menuRoutes);
          resolve(menuRoutes);
        }
      });
    }
  }
};

function getProducerMyInfo() {
  return new Promise((resolve, reject) => {
    producerMyInfo()
      .then(res => {
        let isAnnualNav = false;
        let isProducerAuth = false;
        let resData = res.result || {};
        let pointList = resData.list.filter(i => i.mpID);
        let wellList = resData.list.filter(i => !i.mpID);
        let nowTime = new Date().getTime();

        pointList.forEach(i => {
          let pointWells = i.wells || [];
          pointWells.forEach((w, idx) => {
            let wellTime = new Date(w.timestamp).getTime();
            if ((nowTime - wellTime) / 1000 / 3600 / 24 >= 360) {
              pointWells[idx].isAnnual = true;
              isAnnualNav = true;
            } else {
              pointWells[idx].isAnnual = false;
            }
          });
        });

        wellList.forEach((w, idx) => {
          let wellTime = new Date(w.timestamp).getTime();
          if ((nowTime - wellTime) / 1000 / 3600 / 24 >= 360) {
            wellList[idx].isAnnual = true;
            isAnnualNav = true;
          } else {
            wellList[idx].isAnnual = false;
          }
        });

        // console.log("SET_ANNUALINFO",pointList,wellList)
        resolve({
          producer: resData.producer,
          pointList,
          wellList,
          isAnnualNav
        });
      })
      .catch(err => {
        reject(err);
      });
  });
}

// Get the map of the menu data returned from the background to facilitate the filtering operation. Note: this method is processed according to the actual item menu data format
function getMneuMap(menu) {
  for (let i = 0; i < menu.length; i++) {
    if (!menu[i].subMenu || (menu[i].subMenu && menu[i].subMenu.length == 0)) {
      if (!menuMap[menu[i].path]) {
        menuMap[menu[i].path] = {
          path: menu[i].path,
          icon: menu[i].icon
        };
      }
    } else {
      getMneuMap(menu[i].subMenu);
    }
  }
}
function filterMenuRoute(menu, role, isAnnualNav) {
  return menu.filter(i => {
    if (!i.children) {
      if (i.roles && i.roles.indexOf(role) > -1) {
        if (
          role == 0 &&
          isAnnualNav &&
          i.path == "/wellManagement/annualReview"
        ) {
          i.hidden = false;
          return i;
        }
        return i;
      }
    } else if (i.children.length) {
      i.children = filterMenuRoute(i.children, role, isAnnualNav);
    }
  });
}

export const loadView = view => {
  return () => import(`@/views/${view}`);
};

export default permission;
